<div id="schoolLearnMoreWelcomeTour" class="w-100 jmWidgetPadding" style="background-color: #2C3E50;" [ngStyle]="(isMobile===true)?{'height':'{{modalHeight}}'}:{'height':'700px'}">
	<div style="display: flex; flex-direction: column; color: #ecf0f1; text-align: center; height: 100%;">
		<div *ngIf="iPage===0">
			<div style="padding: 20px; font-weight: 600;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">Welcome to Journeys Map!</div>
			<div style="padding: 20px;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">
				<div *ngIf="cyberId !== '1'">
					Let your interests and skills connect you with careers, while also providing a glimpse into the workforce landscape surrounding you.
				</div>
				<div *ngIf="cyberId === '1'">
					The San Diego Cyber Center of Excellence and the State of California are partnering with Journeys Map on an interactive pilot to map cyber education, trainings, certifications and career pathways in San Diego and other areas of California. You can chart your personal path to a cyber career with the exploration dashboard and zoom in for jobs, salary information and much more.
				</div>
				<br />
				<br />
				Here's how it works.
			</div>
		</div>

		<div *ngIf="iPage===1">
			<div style="padding: 20px; font-weight: 600;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">Interest Survey</div>
			<div style="padding: 20px;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">
				Let your interests match you with career recommendations by completing our simple interest survey.
			</div>
		</div>
		<div *ngIf="iPage===2">
			<div style="padding: 20px; font-weight: 600;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">Skills Matcher</div>
			<div style="padding: 20px;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">
				Interested in seeing how your skills match with potential careers? No problem. We've got that too.
			</div>
		</div>
		<div *ngIf="iPage===3">
			<div style="padding: 20px; font-weight: 600;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">Career Exploration</div>
			<div style="padding: 20px;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">
				Or feel free to dive right in and start exploring careers on your own!
			</div>
		</div>
		<div *ngIf="iPage===4">
			<div style="padding: 20px; font-weight: 600;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">The World Around Me</div>
			<div style="padding: 20px;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'">
				Where you live is a unique place. Start learning about how that might play a factor in your career path.
			</div>
		</div>
		<div style="min-height: 0; height: 100%; padding-top: 10px;">
			<img [src]="modalImage" style="max-width:100%;max-height:100%;" />
		</div>
		<div style="padding:20px;" *ngIf="iPage<4">
			<button class="btn btn-info" (click)="next()">Next</button><br />
		</div>
		<div style="padding:20px;" *ngIf="iPage===4">
			<button class="btn btn-info" (click)="closeModal()">Get Started</button><br />
		</div>

		<div role="button" [ngStyle]="(iPage===4)?{'opacity':'0'}:{}" style="padding: 20px; align-self: flex-end;" [ngClass]="(isMobile===true)?'schoolLearnMoreWelcomeTourCopyMobile':'schoolLearnMoreWelcomeTourCopyDesktop'" (click)="closeModal()">
			Skip Tour
		</div>

		<div style="display: flex; align-self: center; pointer-events: none; cursor: default;">
			<div (click)="jumpTo(0)" role="button">
				<div [ngClass]="(0 > iPageHighestReached)?'schoolLearnMoreWelcomeTourProgressInd colorIndDefault':'schoolLearnMoreWelcomeTourProgressInd colorIndJumpable'" *ngIf="iPage!==0"></div>
				<div class="schoolLearnMoreWelcomeTourProgressInd colorIndCurrent" *ngIf="iPage===0"></div>
			</div>

			<div (click)="jumpTo(1)" role="button">
				<div [ngClass]="(1 > iPageHighestReached)?'schoolLearnMoreWelcomeTourProgressInd colorIndDefault':'schoolLearnMoreWelcomeTourProgressInd colorIndJumpable'" *ngIf="iPage!==1"></div>
				<div class="schoolLearnMoreWelcomeTourProgressInd colorIndCurrent" *ngIf="iPage===1"></div>
			</div>

			<div (click)="jumpTo(2)" role="button">
				<div [ngClass]="(2 > iPageHighestReached)?'schoolLearnMoreWelcomeTourProgressInd colorIndDefault':'schoolLearnMoreWelcomeTourProgressInd colorIndJumpable'" *ngIf="iPage!==2"></div>
				<div class="schoolLearnMoreWelcomeTourProgressInd colorIndCurrent" *ngIf="iPage===2"></div>
			</div>

			<div (click)="jumpTo(3)" role="button">
				<div [ngClass]="(3 > iPageHighestReached)?'schoolLearnMoreWelcomeTourProgressInd colorIndDefault':'schoolLearnMoreWelcomeTourProgressInd colorIndJumpable'" *ngIf="iPage!==3"></div>
				<div class="schoolLearnMoreWelcomeTourProgressInd colorIndCurrent" *ngIf="iPage===3"></div>
			</div>

			<div (click)="jumpTo(4)" role="button">
				<div [ngClass]="(4 > iPageHighestReached)?'schoolLearnMoreWelcomeTourProgressInd colorIndDefault':'schoolLearnMoreWelcomeTourProgressInd colorIndJumpable'" *ngIf="iPage!==4"></div>
				<div class="schoolLearnMoreWelcomeTourProgressInd colorIndCurrent" *ngIf="iPage===4"></div>
			</div>
		</div>
	</div>
</div>

